// Generated by Melange

import * as Curry from "melange.js/curry.js";
import * as Lui_extension from "lui/lui_extension.js";
import * as Lui_protocol from "lui/lui_protocol.js";
import * as Lui_web from "lui.web.dom/shell/lui_web.js";
import * as Mapre_web__Web_attachment_input from "./web_attachment_input.js";
import * as Mapre_web__Web_file_input from "./web_file_input.js";
import * as Mapre_web__Web_markdown from "./web_markdown.js";
import * as Mapre_web__Web_scroll_anchor from "./web_scroll_anchor.js";

function renderer(icons, host) {
  const registry = Lui_extension.registry();
  Lui_extension.register_component(registry, Mapre_web__Web_attachment_input.component());
  Lui_extension.register_component(registry, Mapre_web__Web_file_input.component());
  Lui_extension.register_component(registry, Mapre_web__Web_markdown.component());
  Lui_extension.register_component(registry, Mapre_web__Web_scroll_anchor.component());
  const adapters = Curry._3(Lui_protocol.String_map.add, Mapre_web__Web_scroll_anchor.identifier, Mapre_web__Web_scroll_anchor.adapter, Curry._3(Lui_protocol.String_map.add, Mapre_web__Web_markdown.identifier, Mapre_web__Web_markdown.adapter, Curry._3(Lui_protocol.String_map.add, Mapre_web__Web_file_input.identifier, Mapre_web__Web_file_input.adapter, Curry._3(Lui_protocol.String_map.add, Mapre_web__Web_attachment_input.identifier, Mapre_web__Web_attachment_input.adapter, Lui_protocol.String_map.empty))));
  return [
    Lui_web.create_with_extensions(host, icons, registry, adapters),
    registry
  ];
}

export {
  renderer,
}
/* Lui_extension Not a pure module */
